import { required, optional } from 'AppReact/schema';

export const tableIncidentReport = {
  description: required('string'),
  id: required('integer'),
  incident_datetime: required('jsDate'),
  incident_type: required('string'),
  incident_type_id: required('integer'),
  property_id: required('integer'),
  property_name: required('string'),
  submitted_by: required('string'),
  unit_number: optional('string'),
  unit_id: optional('integer'),
}